<template>
  <div class="modal-alert p-4">
    <div>{{data.text}}</div>
    <div class="footer pt-4">
      <button class="btn alert-button" @click="cancel">{{data.textCancel}}</button>
      <button class="btn alert-button" @click="submit">{{data.textSubmit}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  methods: {
    async submit() {
      if (this.data.onSubmit) {
        this.data.onSubmit()
      }
      this.$emit('close')
    },
    async cancel() {
      if (this.data.onCancel) {
        await this.data.onCancel()
      }
      this.$emit('close')
    }
  }
}
</script>


<style lang="scss" scoped>
.modal-alert {
  height: 100vh;
  width: 100vw;
  color: #fff;
  background: linear-gradient(180deg, $dark-blue 15.1%, #188CB9 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 24px;
}

.footer {
  display: flex;
  justify-content: space-around;
}

.alert-button {
  color: #fff;
  text-transform: uppercase;
}
</style>

